import { useEffect, useState } from 'react';
import type { BranchScaleConfig, LiveScaleWeight } from '../domain/scaleConfig';
import { fetchLiveScaleWeight } from '../infra/fetchLiveScaleWeight';

const POLL_MS = 400;

export function useLiveScaleWeight(args: {
  active: boolean;
  config: BranchScaleConfig | null;
}): {
  reading: LiveScaleWeight | null;
  error: string | null;
} {
  const { active, config } = args;
  const [reading, setReading] = useState<LiveScaleWeight | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!active || !config?.enabled) {
      setReading(null);
      setError(null);
      return;
    }
    let cancelled = false;
    const ac = new AbortController();

    const tick = async () => {
      const result = await fetchLiveScaleWeight(config, ac.signal);
      if (cancelled) return;
      if (result.ok) {
        setReading(result.reading);
        setError(null);
      } else if (result.error !== 'cancelado') {
        setError(result.error);
      }
    };

    void tick();
    const id = setInterval(() => void tick(), POLL_MS);
    return () => {
      cancelled = true;
      ac.abort();
      clearInterval(id);
    };
  }, [active, config?.enabled, config?.agentUrl, config?.protocol, config?.comPort]);

  return { reading, error };
}
